export const Home = () => {
  return <div className="home-page"></div>;
};

export default Home;
